<template>
    <app-wrapper>
        <app-header
            :loan="loan"
            :page="'Make a payment'"
            :floating="'Take care of your missed payment to avoid penalties.'"
            :slim-top="true"
            :show-alert="false"
            medium-max-width="max-w-1000"
            medium-max-width-inner="max-w-500">

            <template #navigation />

            <template #top-left>
                <div><h6 class="font-semibold text-base">Missed Payment</h6></div>
                <div>{{ payment.due_at | date('dddd, MMM D') }}</div>
            </template>
            <template #top-right>
                <div>&nbsp;</div>
                <div>{{ payment.computed_amount | money(2) }}</div>
            </template>

            <template #top-bottom>
                <div class="flex cursor-pointer shadow items-center border py-4 px-5 rounded-lg bg-red-50 border-red-300">
                    <div class="w-2/5 pr-5">
                        <p class="mb-3">Account</p>
                        <p>Account type</p>
                    </div>
                    <div class="w-3/5 text-right font-semibold">
                        <p class="mb-3 truncate" v-text="loan.banking_account.official_name" />
                        <p>{{ formatSubType(loan.banking_account.subtype) }} ({{ loan.banking_account.mask }})</p>
                    </div>
                </div>
            </template>

        </app-header>
        <app-body medium-max-width="max-w-500" footer short>

            <template #main>
                <p class="leading-normal">
                    We couldn’t process your payment using your current bank information. Please update your details or try again process the missed payment.
                </p>

                <div class="flex mt-5">
                    <a @click="() => {
                        retrying = true;
                        window.LogRocket?.track?.('payment_retry_attempted', {
                                loan_id: loan.id,
                                payment_id: payment.id,
                                amount: payment.computed_amount
                            });

                    }" :href="`/account/loans/${loan.id}/recover-payment/${payment.id}/retry`"
                        class="flex flex-auto justify-center py-3 no-underline border text-lg mr-2 border-primary-700 rounded text-primary-700 font-semibold">
                        <template v-if="! retrying">
                            Try Again
                        </template>
                        <template v-else>
                            <i class="fa fa-circle-notch fa-spin" />
                        </template>
                    </a>
                    <a href="#"
                       class="flex flex-auto justify-center py-3 no-underline border text-lg ml-2 rounded text-gray-700 font-semibold">
                        Change Bank
                    </a>
                </div>
            </template>

        </app-body>
    </app-wrapper>
</template>

<script>
    import InteractsWithLoans from '../../../mixins/InteractsWithLoans';

    export default {
        props: ['loan', 'payment'],

        mixins: [InteractsWithLoans],

        data() {
            return {
                retrying: false
            }
        }
    }
</script>